import React, { useState, useEffect } from "react";
import FullScreenLoader from "../../components/Common/Loader";
import PriceValue from "../../components/Common/PriceValue";
import { Tooltip } from "reactstrap";
import { motion } from "framer-motion";
const DEFAULT_IMAGE = "/assets/images/noImage/no-image3.png";

const ProductCards = ({
    Style_ID,
    Image,
    Line1,
    Line2,
    StyleNo,
    LineAmount,
    LineDiscount,
    PriceRemark,
    addingToCart,
    handleAddToCart,
    IS_AddedInCart,
    IS_AddedInEnquiry,
    Status,
    NewArrivalStatus,
    onEnquiry,
}) => {

    const [imgLoaded, setImgLoaded] = useState(false);
    const [imgSrc, setImgSrc] = useState(DEFAULT_IMAGE);   
    const isTrue = (val) => ["YES", "TRUE", "1", "Y"].includes(String(val ?? "").toUpperCase());
    const isInCart = isTrue(IS_AddedInCart);
    const isInEnquiry = isTrue(IS_AddedInEnquiry);
    const hasNewArrival = NewArrivalStatus && String(NewArrivalStatus).trim() !== "";
    const hasStatus = Status && String(Status).trim() !== "";
    const [tooltipOpen, setTooltipOpen] = useState({});

    const toggleTooltip = (id) => {
        setTooltipOpen(prev => ({ ...prev, [id]: !prev[id] }));
    };

    useEffect(() => {
        setImgLoaded(false);
        setImgSrc(Image && Image.trim() !== "" ? Image : DEFAULT_IMAGE);
    }, [Image]);

    return (
        <>
            {addingToCart && <FullScreenLoader />}
            <motion.div
                key={Style_ID}
                className="product-card"
                initial={{ opacity: 0, y: 24, scale: 0.99 }}
                whileInView={{ opacity: 1, y: 0, scale: 1 }}
                viewport={{ once: true, amount: 0.20 }}
                transition={{
                    duration: 0.40,
                    ease: [0.25, 1, 0.5, 1]
                }}
                style={{ willChange: "transform, opacity" }}
            >
                <div className="product-image-wrapper">
                    {hasNewArrival && (
                        <span className="badge badge-new-arrival">
                            {NewArrivalStatus}
                        </span>
                    )}
                    {hasStatus && (
                        <span className="badge badge-status">
                            {Status}
                        </span>
                    )}
                    {!imgLoaded && (
                        <div className="product-image skeleton-box skeleton-image" />
                    )}
                    <a href={`/vault-access-detail/${Style_ID}`}>
                        <img
                            src={imgSrc}
                            alt={StyleNo || "Product Image"}
                            loading="lazy"
                            className="product-image"
                            onLoad={() => setTimeout(() => setImgLoaded(true), 200)}
                            onError={() => {
                                setImgSrc(DEFAULT_IMAGE);
                                setTimeout(() => setImgLoaded(true), 200);
                            }}
                        />
                    </a>
                </div>
                <div className="product-card-lines w-100">
                    <PriceValue
                        lineAmount={LineAmount}
                        lineDiscount={LineDiscount}
                        priceRemark={PriceRemark}
                    />
                    <div className="product-card-name">{Line1}</div>
                    <div className="product-card-detail">{Line2}</div>
                </div>
                <div className="d-flex text-center w-100">
                    <span
                        id={`enquiry-btn-${Style_ID}`}
                        className="w-100 me-2 d-inline-block"
                        style={{ cursor: isInEnquiry ? "not-allowed" : "pointer" }}
                    >
                        <button
                            type="button"
                            className={`btn-animate-enquiry w-100 fs-6 ${isInEnquiry ? "btn-outline-enquiry disabled-btn" : ""
                                }`}
                            disabled={isInEnquiry}
                            onClick={onEnquiry}
                        >
                            {isInEnquiry ? "IN ENQUIRY" : "ENQUIRE NOW"}
                        </button>
                    </span>

                    {isInEnquiry && (
                        <Tooltip
                            fade={false}
                            placement="top"
                            isOpen={!!tooltipOpen[`enquiry-btn-${Style_ID}`]}
                            target={`enquiry-btn-${Style_ID}`}
                            toggle={() => toggleTooltip(`enquiry-btn-${Style_ID}`)}
                        >
                            This product is already added to enquiry
                        </Tooltip>
                    )}

                    <span
                        id={`cart-btn-${Style_ID}`}
                        className="w-100 d-inline-block"
                        style={{ cursor: isInCart || isInEnquiry ? "not-allowed" : "pointer" }}
                    >
                        <button
                            type="button"
                            className={`btn-animate-addtocart w-100 fs-6 ${isInCart
                                    ? "btn-outline-cart disabled-btn"
                                    : isInEnquiry
                                        ? "disabled-btn"
                                        : ""
                                }`}
                            disabled={isInCart || isInEnquiry || addingToCart}
                            onClick={handleAddToCart}
                        >
                            {isInCart ? "IN CART" : "ADD TO CART"}
                        </button>
                    </span>

                    {(isInCart || isInEnquiry) && (
                        <Tooltip
                            fade={false}
                            placement="top"
                            isOpen={!!tooltipOpen[`cart-btn-${Style_ID}`]}
                            target={`cart-btn-${Style_ID}`}
                            toggle={() => toggleTooltip(`cart-btn-${Style_ID}`)}
                        >
                            {isInCart
                                ? "This product is already in your cart"
                                : "Products in enquiry can’t be added to cart"}
                        </Tooltip>
                    )}

                </div>
            </motion.div>
        </>
    );
};

export default ProductCards;
